import type { PlayerExercise } from '@/views/workout-player/types';

/**
 * Time-weighted workout completion from player state.
 * Includes fractional progress within the current exercise.
 */
export function getWorkoutCompletionPercentage(
  exercises: PlayerExercise[],
  exerciseIdx: number,
  elapsedTimeMs: number
): number {
  if (!exercises.length) return 0;

  const totalTime = exercises.reduce((sum, exercise) => sum + exercise.time, 0);
  if (totalTime <= 0) return 0;

  const safeIdx = Math.min(Math.max(exerciseIdx, 0), exercises.length);
  const completedTime = exercises.slice(0, safeIdx).reduce((sum, exercise) => sum + exercise.time, 0);

  if (safeIdx >= exercises.length) {
    return 100;
  }

  const current = exercises[safeIdx];
  const currentElapsed = Math.min(Math.max(elapsedTimeMs, 0), current.time);
  const ratio = (completedTime + currentElapsed) / totalTime;
  return Math.min(100, Math.max(0, ratio * 100));
}
